(function ($) {
  const $toggle = $(".js-filters-toggle");
  const $filters = $(".filters__mobile");

  $toggle.on("click", function (e) {
    e.preventDefault();

    if (!$filters.hasClass("open")) {
      $filters.addClass("open");
    } else {
      $filters.removeClass("open");
    }
  });
})(jQuery);
